import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics 4 — only loads when REACT_APP_GA4_MEASUREMENT_ID is set.
 * Injects gtag once, then tracks SPA route changes as page_view events.
 */
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA4_ID) return;
    if (window.__ga4Loaded) return;

    const s1 = document.createElement('script');
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s1);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA4_ID, { send_page_view: false });
    window.__ga4Loaded = true;
  }, []);

  useEffect(() => {
    if (!GA4_ID || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location.pathname, location.search]);

  return null;
};

export default GoogleAnalytics;
